import React from 'react';

export default function DownArrowIcon(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 12 6.9"
      style={{ enableBackground: 'new 0 0 12 6.9' }}
      xmlSpace="preserve"
      {...props}
    >
      <polygon
        id="XMLID_1402_"
        points="6,6.9 0,0.9 0.9,0 6,5.1 11.1,0 12,0.9 "
      />
    </svg>
  );
}
